import React, { useState } from 'react';
import './DirectMessageApp.scss';
import * as S from '../../scss/theme';
import DirectMessageWindow from './DirectMessageWindow';
import MyTreeView from './MyTreeViewTec';
import StuList from './StuList';

const DirectMessageApp = () => {
    const [selectedNodeItem, setSelectedNodeItem] = useState(null);
    const [selectedStudents, setSelectedStudents] = useState([]);

    const handleStudentSelection = (students) => {
        setSelectedStudents(students);
    };

    const handleStudentRemove = (studentToRemove) => {
        const updatedStudents = selectedStudents.filter(
            student => student.id !== studentToRemove.id
        );
        setSelectedStudents(updatedStudents);
    };

    return (
        <S.Section>
            <div className="DirectMessageApp">
                <section className="sec-treeview">
                    <MyTreeView setSelectedNodeItem={setSelectedNodeItem} />
                </section>

                <section className="sec-stuList">
                    <StuList
                        selectedNodeItem={selectedNodeItem}
                        onStudentSelection={handleStudentSelection}
                        selectedStudents={selectedStudents}
                    />
                </section>

                <section className="sec-chatwindow">
                    <DirectMessageWindow
                        selectedStudents={selectedStudents}
                        isOpen={true}
                        onClose={() => {}}
                        onStudentRemove={handleStudentRemove}
                    />
                </section>
            </div>
        </S.Section>
    );
};

export default DirectMessageApp;
